<template>
  <div class="EntCoop maxBox">
    <div class="EntCoop_banner banner"></div>

    <div
      class="new-infor"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255,255, 0.8)"
     
    >
      <Card :data="lust" @toInformation="toInformation" />
      <el-pagination
        background
        layout="prev, pager, next"
        next-text="下一页"
        prev-text="上一页"
        :total="totalSize"
        :current-page="currentPage"
        @current-change="current_change"
        @next-click="next_click"
        @prev-click="prev_click"
        :page-size="pageSize"
      >
      </el-pagination>
    </div>
   
  </div>
</template>

<script>
import Card from "../components/itemcard.vue";
export default {
  name: "Vue2TemplateEntcoop",
  components: { Card },
  data() {
    return {
      currentPage: 1,
      current_page: 1,
      totalSize: 1,
      pageSize: 6,
      lust: "",
      loading: true,
    };
  },
  created() {
    this.requestent();
  },
  methods: {
    requestent() {
      const start = (this.current_page - 1) * this.pageSize + 1;
      this.$axios({
        method: "get",
        url:
          "Data?uid=39&layer=newsinfo&operation=query&outfields=id,pic,publishtime,title,subtitle&start=" +
          start +
          "&count=" +
          this.pageSize +
          "&orderfields=publishtime%2520desc",
      }).then((res) => {
        if (res.data.state) {
          this.loading = false;

          this.totalSize = res.data.size;
          this.lust = res.data.data;
        }
      });
    },
    // id为查询条件
    toInformation(data) {
      // 路由挑选
      this.$router.push({
        path: "/newsinfo",
      });
      this.$store.commit("CHANGE_PAGE", "/newsinfo");
      this.$store.commit("ParamsId", data);
    },
    // 获取当前页码
    current_change(val) {
      this.current_page = val;
      this.requestent();
    },
    //下一页
    next_click(n) {
      this.current_page = n;
      this.requestent();
      console.log(n);
    },
    //上一页
    prev_click(p) {
      this.current_page = p;
      this.requestent();
      console.log(p);
    },
  },
};
</script>

<style>
.EntCoop_banner {
  background: url("../image/banner_news.jpg") no-repeat center center;
}
.new-infor {
  width: 100%;
  min-width: 1200px;
  background: #f5f7fa;
}
</style>